<template>
    <transition name="modal">
        <div class="modal-mask sub-form">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="pull-right">
                        <button type="button" class="close" aria-label="Close" @click="closeModal"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div>
                        <profile></profile>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            showAccount: true,
            showProfile: false,
            // Managing tabs
            activeTabName: '',
            tabs: [
              { 
                name: 'account',
                displayName: 'Account',
              },
              { 
                name: 'profile',
                displayName: 'Profile',
              }
            ],
        }
    },
    
    computed: {

        ...mapState('profile', {
            successMessage: state => state.successMessage,
            showSuccess: state => state.showSuccess,
        }),
    },

    methods:{
        /**
         * Set active tab
         * @param {string}
         */
        setActiveTabName(name) {
            this.activeTabName = name;
            VueStore.dispatch('profile/setActiveTab', name);
        },

        /**
         * Determine which tab content to display
         * @parm {string, string}
         */
        displayContents(activeTabName, name) {
            return this.activeTabName === name;
        },

        /*
         * Close profile modal
         */
        closeModal: function(){
            VueStore.dispatch('profile/validateModal');
        },

        /**
         * Set active tab as first item in tabs array (acccount)
         */
        getActiveTab(){
            this.activeTabName = this.tabs[0].name;
            VueStore.dispatch('profile/setActiveTab', this.tabs[0].name);
        },

        getUserData(){
            VueStore.dispatch('user/getUserData');
        },

        resetPasswordAsterisk(){
            VueStore.dispatch('profile/setBoolean', {key: 'password', bool: '************'});
        }

    },

    created(){
    },

    mounted(){
        this.getActiveTab();
        this.getUserData();
        this.resetPasswordAsterisk();
    }
}
</script>

<style>
body{
    /*overflow-y: auto;  */
}

.modal-wrapper {
    width: 800px;
    height: calc(100% - 265px);
    padding: 20px 10px;

}

.modal-container {
    width: 800px;
    padding: 20px 10px;

}

/* Mobile: the fixed 800px width overflows small screens; fill the screen
   and let the modal body scroll if the form is taller than the viewport. */
@media screen and (max-width: 768px){
    .modal-wrapper {
        width: 100%;
        padding: 10px 0;
    }

    .modal-container {
        width: 100%;
        max-height: calc(100vh - 20px);
        overflow-y: auto;
        overflow-x: hidden;
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>